import { DropDown } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { COUNTRY_NAMES } from './countries-data';
import type { CountryListDropdownProps as Props } from './types';

export const CountryListDropdown = memo(
  ({
    className,
    placeholder,
    label = 'Country',
    name = 'country',
    noLabel,
    ...props
  }: Props) => {
    const { control } = useFormContext();

    const options = COUNTRY_NAMES.map((c) => ({
      key: c,
      value: c,
      label: c,
    }));

    const renderItem = useCallback(
      (optionLabel: string) => <span>{optionLabel}</span>,
      []
    );

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DropDown
            className={classnames('CountryListDropdown', className)}
            label={noLabel ? undefined : label}
            placeholder={placeholder || label}
            options={options}
            // renderItem={renderItem}
            {...field}
            {...props}
          />
        )}
      />
    );
  }
);

CountryListDropdown.displayName = 'CountryListDropdown';
